module.exports = zxcvbn;